import { render, staticRenderFns } from "./OfferList.vue?vue&type=template&id=fbdc06b8&scoped=true"
import script from "./OfferList.vue?vue&type=script&lang=js"
export * from "./OfferList.vue?vue&type=script&lang=js"
import style0 from "./OfferList.vue?vue&type=style&index=0&id=fbdc06b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbdc06b8",
  null
  
)

export default component.exports